import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

interface AppDownloadDialogProps {
  isOn: boolean;
  setIsOn: React.Dispatch<React.SetStateAction<boolean>>;
  handleInstallClick: () => void;
}

export const AppDownloadDialog: React.FC<AppDownloadDialogProps> = ({
  isOn,
  setIsOn,
  handleInstallClick,
}) => {
  return (
    <Dialog open={isOn}>
      <DialogTitle>ダウンロードの確認</DialogTitle>
      <DialogContent>
        <DialogContentText>
          このアプリをデバイスにダウンロードしますか？
        </DialogContentText>
        <DialogActions sx={{ paddingBottom: 0 }}>
          <Button onClick={() => setIsOn(false)}>後で</Button>
          <Button onClick={handleInstallClick}>ダウンロード</Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};
